import axios from "../../axios";
import { toast } from "react-toastify";
import { ADD_MAIN_AND_SUB_HSN, DELETE_MAIN_AND_SUB_HSN, GET_MAIN_AND_SUB_HSN, UPDATE_MAIN_AND_SUB_HSN } from "../types";

export const getMainAndSubHsn = (params) => async (dispatch) => {
  try {
    const res = await axios.get("/mainAndSubHsn/all", { params });

    if (res.data.code === 1) {
      dispatch({
        type: "GET_MAIN_AND_SUB_HSN",
        payload: {
          data: res.data.data || [],
          pagination: res.data.pagination || {},
          totalCount: res.data.totalCount || 0,
        },
      });
    }
  } catch (err) {
    console.error("Failed to fetch HSN data:", err);
  }
};


// export const getMainAndSubHsn = (params) => async (dispatch) => {
//   try {
//     const res = await axios.get('/mainAndSubHsn/all', { params });

//     if (res.data.code === 1) {
//       dispatch({ 
//         type: GET_MAIN_AND_SUB_HSN, 
//         payload: {
//           list: res.data.data.rows, // Actual data rows
//           pagination: {
//             currentPage: res.data.data.page, // Current page from backend
//             totalPages: res.data.data.totalPages, // Total pages from backend
//             hasNextPage: res.data.data.hasNextPage, // Next page availability
//             hasPreviousPage: res.data.data.hasPreviousPage, // Previous page availability
//             totalProducts: res.data.data.total // Total number of products/records
//           }
//         }
//       });
//     } 
//   } catch (err) {
//     if(err.response?.data?.errors?.[0]?.message){
//       toast.error(err.response.data.errors[0].message);
//     }
//   }
// };

export const addMainAndSubHsn = (formData) => async (dispatch) => {
  try {
    const res = await axios.post('/mainAndSubHsn/add', formData);

    if (res.data.code === 1) {
      dispatch({ type: ADD_MAIN_AND_SUB_HSN, payload: res.data.data });
      setTimeout(() => {
        toast.success("Hsn added successfully!");
      }, 1000);
    }
    if (res.data.code === 0) {
      setTimeout(() => {
        toast.error(res.data.message);
      }, 1000);
    }
  } catch (err) {
    if (err.response.data.errors[0].message) {
      toast.error(err.response.data.errors[0].message);
    }
  }
};

export const updateMainAndSubHsn = (formData) => async (dispatch) => {
  try {
    const res = await axios.post(`/mainAndSubHsn/update`, formData);

    if (res.data.code === 1) {
      dispatch({ type: UPDATE_MAIN_AND_SUB_HSN, payload: res.data.data });

      setTimeout(() => {
        toast.success("Hsn updated successfully!");
      }, 1000);
    }
  } catch (err) {
    if (err.response.data.errors[0].message) {
      toast.error(err.response.data.errors[0].message);
    }
    // toast.error("Failed to update Hsn. Please try again.");
  }
};

// Delete MainAndSubHsn
export const deleteMainAndSubHsn = (id) => async (dispatch) => {
  try {
    if (!id) {
      toast.error("Please select any record");
      return false;
    }
    const res = await axios.post(`/mainAndSubHsn/delete/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_MAIN_AND_SUB_HSN, payload: { id } });
      setTimeout(() => {
        toast.success("Hsn deleted successfully!");
      }, 1000);
    }
  } catch (err) {
    if (err.response.data.errors[0].message) {
      toast.error(err.response.data.errors[0].message);
    }
    // toast.error("Failed to delete Hsn. Please try again.");
  }
};


